module.exports = angular.module('msi.dropdown', ['ui.bootstrap']).name;
